<template>
    <section class="ifr__section ifr__section--signals">
        <img class="ifr__bg" src="../assets/img/dementia-warnings-test.png"/>
        <div class="-ui-container">
            <div class="-ui-grid">
                <div class="-ui-col-60"></div>
                <div class="-ui-col-40">
                    <header class="ifr__header ifr__header--intro">
                        <h4>{{ $t('signals.h4') }}</h4>
                        <h3 v-html="$t('signals.h3')"></h3>
                        <div class="ifr__header-content" v-html="$t('signals.content')"></div>
                    </header>
                    <footer>
                        <a class="ifr__btn" href="http://www.paho.org/lets-talk-about-dementia/warning-signs" target="_blank">
                            <span>
                                {{ $t('signals.btn') }}
                                <svg width="14px" height="24px" viewBox="0 0 14 24">
                                    <polygon id="Path" points="0 2.3625 2.35520833 0 14 11.6666667 14 11.6666667 14 11.6666667 2.35520833 23.3333333 0 20.9708333 9.28229167 11.6666667"></polygon>
                                </svg>
                            </span>
                            <span>
                                {{ $t('signals.btn') }}
                                <svg width="14px" height="24px" viewBox="0 0 14 24">
                                    <polygon id="Path" points="0 2.3625 2.35520833 0 14 11.6666667 14 11.6666667 14 11.6666667 2.35520833 23.3333333 0 20.9708333 9.28229167 11.6666667"></polygon>
                                </svg>
                            </span>
                            
                        </a>
                    </footer>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'signals'
}
</script>

